import { useState, useEffect } from 'react';
import ax, { SEO_LINKS } from '%/axios';

const useSeoLinks = () => {
  const [seoLinks, setSeoLinks] = useState({});

  const getSeoLinks = async () => {

    try {
      const res = await ax(SEO_LINKS);
      if (res) {
        const red = Object.entries(res).reduce((acc, [key, value]) => {
          acc[key] = '/' + value
          return acc;
        }, {})
        setSeoLinks(red);
      }
    } catch (er) {
      console.error(er);
    }
  }
  useEffect(() => {
    getSeoLinks();
  }, [])

  return {
    seoLinks
  }
}

export default useSeoLinks;